module.exports = __webpack_public_path__ + "static/media/appstore-1a.4fb3dd4a.png";